/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   getQueryMaxPrice
 */

import type {
  Filters,
  FloorplanListing,
  Listable,
  NormalFloorplanListingData,
  Property,
} from '@zcode/state-type'
import { groupFloorplansByBedsBaths } from '../helpers'
import { getQueryBuildingMaxPrice } from './getQueryBuildingMaxPrice'
import { getQueryListingMaxPrice } from './getQueryListingMaxPrice'

export const getQueryMaxPrice = ({
  entity,
  filters,
  floorplan,
}: {
  entity: Listable | Property
  filters: Partial<Filters> | undefined
  floorplan?: FloorplanListing<NormalFloorplanListingData> | null | undefined
}) => {
  const { floorplans: entityFloorplans, isBuilding, isFloorplan } = entity
  if (isBuilding && !isFloorplan) {
    if (floorplan) {
      const floorplansByBedsBaths = groupFloorplansByBedsBaths(entityFloorplans)
      const { maxPrice } = floorplansByBedsBaths.get(floorplan.bedsBathsTxt) ?? {}
      return getQueryListingMaxPrice({
        price: maxPrice,
        filters,
      })
    }
    return getQueryBuildingMaxPrice({
      price: entity.maxPrice || entity.price,
      filters,
    })
  }

  return getQueryListingMaxPrice({
    price: entity.maxPrice || entity.price,
    filters,
  })
}
